module.exports = __webpack_public_path__ + "static/img/downloadpopup2.2a166af2.webp";